module.exports = __webpack_public_path__ + "img/reddit-circle.d59cbf65.svg";